// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--1P2lU","gray":"Section-module--gray--1NKq4","primary":"Section-module--primary--2lQ6i","container":"Section-module--container--2JHg5"};